import { EventDetailSkeleton } from "./EventDetailSkeleton"

export const EventLoadingState = () => {
    return <EventDetailSkeleton />
}

